// extracted by mini-css-extract-plugin
module.exports = {"breakpointMD":"750px","breakpointLG":"1250px","breakpointXL":"1800px","loading":"Link-module--loading--3lEPx"};